/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    inserirConvenio(Convenio) {
        return axiosJwt.post(`${api}/convenios`, Convenio)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    AlterarConvenio(Convenio) {
        return axiosJwt.post(`${api}/convenios/alterar`, Convenio)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirAcoes(acoes) {
        return axiosJwt.post(`${api}/convenios/acoes/inserir`, acoes)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarAcoes(acoes) {
        return axiosJwt.post(`${api}/convenios/acoes/atualizar`, acoes)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirAcoes(id) {
        return axiosJwt.patch(`${api}/convenios/acoes/excluir/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirAditivo(aditivo) {
        return axiosJwt.post(`${api}/convenios/InserirAditivos`, aditivo)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirAditivoSemIntegracao(aditivo) {
        const formData = new FormData()
        formData.append('idConvenio', aditivo.idConvenio)
        formData.append('dataAditivo', aditivo.dataAditivo)
        formData.append('objeto', aditivo.objeto)
        formData.append('tipoAditivo', aditivo.tipoAditivo)
        formData.append('dataProrrogada', aditivo.dataProrrogada)
        formData.append('valorAditivo', aditivo.valorAditivo)
        formData.append('statusAditivo', aditivo.statusAditivo)
        formData.append('arquivo', aditivo.arquivo)
        formData.append('nomeArquivo', aditivo.nomeArquivo)
        return axiosJwt.post(`${api}/convenios/inseriraditivosemintegracao`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    alterarAditivo(aditivo) {
        const formData = new FormData()
        formData.append('idAditivo', aditivo.idAditivo)
        formData.append('idConvenio', aditivo.idConvenio)
        formData.append('dataAditivo', aditivo.dataAditivo)
        formData.append('objeto', aditivo.objeto)
        formData.append('tipoAditivo', aditivo.tipoAditivo)
        formData.append('dataProrrogada', aditivo.dataProrrogada)
        formData.append('valorAditivo', aditivo.valorAditivo)
        formData.append('statusAditivo', aditivo.statusAditivo)
        formData.append('arquivo', aditivo.arquivo)
        formData.append('nomeArquivo', aditivo.nomeArquivo)
        return axiosJwt.post(`${api}/convenios/AlterarAditivos`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    downloadDocumentoAditivo(idAditivo) {
        return axiosJwt
            .get(`${api}/convenios/aditivo/download/${idAditivo}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirAplicacaoRecurso(Recurso) {
        return axiosJwt.post(`${api}/convenios/inserirAplicacaoRecurso`, Recurso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarValorRecursoRM(id) {
        return axiosJwt
            .get(`${api}/convenios/atualizarValorRecursoRM/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })

    },
    atualizarAplicacaoRecurso(Recurso) {
        return axiosJwt.post(`${api}/convenios/atualizarAplicacaoRecurso/{id}`, Recurso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirCronogramaDesembolso(cronograma) {
        return axiosJwt.post(`${api}/convenios/InserirCronogramasDesembolsos`, cronograma)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    AlterarCronogramaDesembolso(cronograma) {
        return axiosJwt.post(`${api}/convenios/AlterarCronogramasDesembolsos`, cronograma)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirRateioComprometimento(rateio) {
        return axiosJwt.post(`${api}/convenios/InserirRateioComprometimento`, rateio)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    AlterarRateioComprometimento(rateio) {
        return axiosJwt.post(`${api}/convenios/AlterarRateioComprometimento`, rateio)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    InserirCronogramaRecebimento(cronograma) {
        return axiosJwt.post(`${api}/convenios/InserirCronogramaRecebimento`, cronograma)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    AlterarCronogramaRecebimento(cronograma) {
        return axiosJwt.post(`${api}/convenios/AlterarCronogramaRecebimento`, cronograma)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ExcluirCronogramaRecebimento(idCronogramaRecebimento) {
        return axiosJwt
            .get(`${api}/convenios/DeletarCronogramaRecebimento/${idCronogramaRecebimento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPrestacaoContasMensal(prestacao) {
        return axiosJwt.post(`${api}/convenios/inserirPrestacaoContaMensal`, prestacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarPrestacaoContasMensal(prestacao) {
        return axiosJwt.post(`${api}/convenios/atualizarPrestacaoContaMensal`, prestacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    aprovarPrestacaoContaMensal(idPrestacaoContasMensal) {
        return axiosJwt
            .post(`${api}/convenios/aprovarprestacaocontamensal/${idPrestacaoContasMensal}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reprovarPrestacaoContaMensal(prestacao) {
        return axiosJwt
            .post(`${api}/convenios/reprovarprestacaocontamensal`, prestacao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    bloquearLancamentos(prestacao) {
        return axiosJwt
            .post(`${api}/convenios/bloquearlancamentos`, prestacao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    desbloquearLancamentos(prestacao) {
        return axiosJwt
            .post(`${api}/convenios/desbloquearlancamentos`, prestacao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPrestacaoContasFinal(prestacao) {
        return axiosJwt.post(`${api}/convenios/inserirPrestacaoContasFinal`, prestacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarPrestacaoContaFinal(prestacao) {
        return axiosJwt.post(`${api}/convenios/atualizarPrestacaoContaFinal`, prestacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirPrestacaoContaFinal(id) {
        return axiosJwt.get(`${api}/convenios/excluirPrestacaoContaFinal/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDocumentosPrestacaoContasFinal(documento) {
        const formData = new FormData()
        formData.append('id_Documento', documento.id_Documento)
        formData.append('id_Convenio', documento.id_Convenio)
        formData.append('idPrestacaoContasFinal', documento.idPrestacaoContasFinal)
        formData.append('id_TipoDocumento', documento.id_TipoDocumento)
        formData.append('vcDescricaoDocumento', documento.vcDescricaoDocumento)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)

        return axiosJwt.post(`${api}/convenios/InserirDocumentoConvenio`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirDocumentosPrestacaoContasFinal(idLancamento) {
        return axiosJwt
            .get(`${api}/convenios/ExcluirDocumentoConvenio/${idLancamento}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterListaAplicacaoRecursos(idConvenio) {
        return axiosJwt
            .get(`${api}/convenios/ObterAplicacoesRecursos/${idConvenio}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterTodos() {
        return axiosJwt
            .get(`${api}/convenios`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterGestores() {
        return axiosJwt
            .get(`${api}/convenios/gestores`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterUnidades() {
        return axiosJwt
            .get(`${api}/convenios/unidades`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterNaturezas() {
        return axiosJwt
            .get(`${api}/convenios/naturezas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterProjetosPorUnidade(vcCodUnidade) {
        return axiosJwt
            .get(`${api}/convenios/projetos/${vcCodUnidade}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAcoesPorProjeto(codProjeto) {
        return axiosJwt
            .get(`${api}/convenios/acoes/projetos/${codProjeto}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAcoesConvenio(idConvenio) {
        return axiosJwt
            .get(`${api}/convenios/acoes/${idConvenio}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterNaturezasPorAcao(idConvenio, idAcao) {
        return axiosJwt
            .get(`${api}/convenios/ListarNaturezasporAcao/${idConvenio}/${idAcao}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        return axiosJwt
            .get(`${api}/convenios/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterConvenioDocumentoModelos(convenioId, tipoDocumento) {
        return axiosJwt
            .get(`${api}/convenios/${convenioId}/${tipoDocumento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterImpostos() {
        return axiosJwt
            .get(`${api}/convenios/impostos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadModelo(convenioId, modeloId, tipoDocumento) {
        return axiosJwt
            .get(
                `${api}/convenios/${convenioId}/${tipoDocumento}/modelo/${modeloId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    uploadModelo(convenioId, tipo, modelo, tipoDocumento) {
        const formData = new FormData()
        formData.append('convenioId', convenioId)
        formData.append('modeloId', modelo.modeloId)
        formData.append('arquivo', modelo.arquivo)

        return axiosJwt
            .post(
                `${api}/convenios/${convenioId}/${tipoDocumento}/modelo/${tipo}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumento(convenioId, modeloId, tipoDocumento) {
        return axiosJwt
            .get(
                `${api}/convenios/${convenioId}/${tipoDocumento}/documento/${modeloId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterProcessosPorNumeroAta(numeroAta) {
        return axiosJwt.get(`${api}/convenios/obterprocessosatapornumeroata/${numeroAta}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterFornecedor(cnpjcpf) {
        return axiosJwt.get(`${api}/convenios/obterfornecedor/${cnpjcpf}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPrestacaoContaMensal(id) {
        return axiosJwt.get(`${api}/convenios/ObterPrestacaoContaMensal/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterDocumentosPrestacaoContaFinal(idPrestacaoFinal) {
        return axiosJwt.get(`${api}/convenios/ObterDocumentoConvenioPorIdPrestacaoFinal/${idPrestacaoFinal}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    glosarPrestacaoContasFinal(prestacao) {
        return axiosJwt.post(`${api}/convenios/glosarprestacaocontasfinal`, prestacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    conferirPrestacaoContasFinal(id) {
        return axiosJwt.get(`${api}/convenios/ConferirPrestacaoContasFinal/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    resetarPrestacaoContasFinal(id) {
        return axiosJwt.get(`${api}/convenios/ResetarPrestacaoContasFinal/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    encerrarConvenio(id) {
        return axiosJwt.get(`${api}/convenios/EncerrarConvenio/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    // inserirDocumento(documento) {
    //     const formData = new FormData()
    //     formData.append('tipoDocumentoId', documento.tipoDocumentoId)
    //     formData.append('idContrato', documento.idContrato)
    //     formData.append('descricao', documento.descricao)
    //     formData.append('arquivo', documento.arquivo)
    //     formData.append('justificativaApostilamento', documento.justificativaApostilamento)
    //     formData.append('isApostilamento', documento.isApostilamento)

    //     return axiosJwt.post(`${api}/contratos/${documento.idContrato}/documentos`, formData, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data'
    //             }
    //         })
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // excluirDocumento(documento) {
    //     return axiosJwt.put(`${api}/contratos/${documento.idContrato}/documentos/${documento.documentoContratoId}`, documento)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    obterTiposDocumentos() {
        return axiosJwt
            .get(`${api}/convenios/ObterTiposDocumentos`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterDocumento() {
        return axiosJwt
            .get(`${api}/convenios/docx`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAplicacaoRecurso(idAplicacaoRecurso) {
        return axiosJwt
            .get(`${api}/convenios/deletaraplicacaorecurso/${idAplicacaoRecurso}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDespesasPorConvenio(id) {
        return axiosJwt
            .get(`${api}/convenios/${id}/obterdespesas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirCronogramaDesembolso(idCronogramaDesembolso) {
        return axiosJwt
            .get(`${api}/convenios/deletarcronogramadesembolso/${idCronogramaDesembolso}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCronogramaDesembolsoPorId(idCronogramaDesembolso) {
        return axiosJwt
            .get(`${api}/convenios/obtercronogramadesembolsoporid/${idCronogramaDesembolso}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoPorCronogramaDesembolso(idConvenio, idCronogramaDesembolso) {
        return axiosJwt
            .get(`${api}/convenios/${idConvenio}/comprometimentos/${idCronogramaDesembolso}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoPorCronogramaRecebimento(idConvenio, idCronogramaRecebimento) {
        return axiosJwt
            .get(`${api}/convenios/${idConvenio}/comprometimentos/cronogramarecebimento/${idCronogramaRecebimento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    salvarRateios(comprometimentoRateios) {
        return axiosJwt
            .post(`${api}/convenios/${comprometimentoRateios.idConvenio}/comprometimentos/${comprometimentoRateios.idComprometimentoRequisicao}`, comprometimentoRateios)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    comprometer(comprometimento) {
        return axiosJwt
            .post(`${api}/convenios/${comprometimento.idConvenio}/comprometimentos/${comprometimento.idComprometimentoRequisicao}/comprometercronogramadesembolso`, comprometimento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    descomprometer(comprometimento) {
        return axiosJwt
            .post(`${api}/convenios/${comprometimento.idContrato}/comprometimentos/${comprometimento.idComprometimentoRequisicao}/descomprometercronogramadesembolso`, comprometimento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    comprometerCronogramaRecebimento(comprometimento) {
        return axiosJwt
            .post(`${api}/convenios/${comprometimento.idConvenio}/comprometimentos/${comprometimento.idComprometimentoRequisicao}/comprometercronogramarecebimento`, comprometimento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    descomprometerCronogramaRecebimento(comprometimento) {
        return axiosJwt
            .post(`${api}/convenios/${comprometimento.idContrato}/comprometimentos/${comprometimento.idComprometimentoRequisicao}/descomprometercronogramarecebimento`, comprometimento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    bloquearDesbloquear(bloquearDesbloquearDto) {
        return axiosJwt
            .patch(
                `${api}/convenios/${bloquearDesbloquearDto.idConvenio}/comprometimentos/${bloquearDesbloquearDto.idComprometimentoRequisicao}/bloqueardesbloquear`,
                bloquearDesbloquearDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    verificarSaldoNatureza(comprometimentos) {
        return axiosJwt
            .post(`${api}/convenios/${comprometimentos.idConvenio}/comprometimentos/verificarsaldonatureza`, comprometimentos)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirRateioComprometimento(idRateioComprometimento) {
        return axiosJwt
            .get(`${api}/convenios/deletarrateiocomprometimento/${idRateioComprometimento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirPrestacaoContaMensal(idPrestacaoContasMensal) {
        return axiosJwt
            .get(`${api}/convenios/deletarprestacaocontamensal/${idPrestacaoContasMensal}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAditivos(id) {
        return axiosJwt
            .get(`${api}/convenios/DeletarAditivo/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ativarAditivos(id) {
        return axiosJwt
            .get(`${api}/convenios/AtivarAditivo/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposConveniosRM() {
        return axiosJwt
            .get(`${api}/convenios/ObterTiposConvenios`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterTipoProdutoFaturamentoRM() {
        return axiosJwt
            .get(`${api}/convenios/ObterTipoProdutoFaturamento`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterTipoNaturezaRM() {
        return axiosJwt
            .get(`${api}/convenios/ObterTipoNatureza`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterVendedoresRM() {
        return axiosJwt
            .get(`${api}/convenios/ObterVendedores`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterRepresentantesRM() {
        return axiosJwt
            .get(`${api}/convenios/ObterRepresentantes`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    IntegrarConvenioRM(id) {
        return axiosJwt
            .get(`${api}/convenios/IntegrarConvenioRM/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    RelatorioF02805DemonstrativoExecucaoSintetico(idConvenio, modelo) {
        return axiosJwt
            .get(`${api}/convenios/RelatorioF02805DemonstrativoExecucaoSintetico/${idConvenio}/${modelo}`, {
                responseType: 'blob'
            })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    RelatorioF02806RelacaoPagamentosEfetuados(idConvenio, modelo) {
        return axiosJwt
            .get(`${api}/convenios/RelatorioF02806RelacaoPagamentosEfetuados/${idConvenio}/${modelo}`, { responseType: 'blob' })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    RelatorioF2807RelacaoPagamentosEfetuadosRecursosParceiro(idConvenio, modelo) {
        return axiosJwt
            .get(`${api}/convenios/RelatorioF2807RelacaoPagamentosEfetuadosRecursosParceiro/${idConvenio}/${modelo}`, { responseType: 'blob' })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    RelatorioF02808RelDespesasEconomicasParceiros(idConvenio, modelo) {
        return axiosJwt
            .get(`${api}/convenios/RelatorioF02808RelDespesasEconomicasParceiros/${idConvenio}/${modelo}`, { responseType: 'blob' })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    RelatorioF02809DeclaracaoDeLicitacao(idConvenio, modelo) {
        return axiosJwt
            .get(`${api}/convenios/relatoriof02809declaracaodelicitacao/${idConvenio}/${modelo}`, { responseType: 'blob' })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    RelatorioExtratoPrestacaoContas(idConvenio, modelo) {
        return axiosJwt
            .get(`${api}/convenios/RelatorioExtratoPrestacaoContas/${idConvenio}/${modelo}`, { responseType: 'blob' })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    relatorioAporteRecursosParceiro(idConvenio, modelo) {
        return axiosJwt
            .get(`${api}/convenios/relatorioaporterecursosparceiro/${idConvenio}/${modelo}`, { responseType: 'blob' })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    downloadDocumentoPrestacaoFinal(idDocumento) {
        return axiosJwt
            .get(`${api}/convenios/DownloadDocumentoPorId/${idDocumento}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumentoConvenioFinalPorId(idConvenio, idDocumento) {
        return axiosJwt
            .get(`${api}/convenios/DownloadDocumentoConvenioFinalPorId/${idConvenio}/${idDocumento}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarDocumentoPrestacaoContasConvenio(id) {
        return axiosJwt
            .get(`${api}/convenios/ListarDocumentoPrestacaoContasConvenio/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    async downloadDocumentoAssinado(id,tipoDocumento) {
        return await axiosJwt
            .get(`${api}/convenios/DownloadDocumentoAssinado/${id}/${tipoDocumento}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    DeletarDocumentoPrestacaoContasConvenio(obj) {
        return axiosJwt.post(`${api}/convenios/DeletarDocumentoPrestacaoContasConvenio`, obj)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    InserirDocumentoPrestacaoContasConvenio(obj) {
        if (obj.arquivo == null) {
            return axiosJwt.post(`${api}/convenios/InserirDocumentoPrestacaoContasConvenio`, obj)
                .then((response) => {
                    return response.data
                }).catch((error) => {
                    return errorHandler(error)
                })
        } else {
            const formData = new FormData()
            formData.append('IdConvenio', obj.idConvenio)
            formData.append('IdDocumento', obj.idDocumento)
            formData.append('vcObservacoes', obj.vcObservacoes)
            formData.append('vcNomeArquivo', obj.vcNomeArquivo)
            formData.append('arquivo', obj.arquivo)
            return axiosJwt.post(`${api}/convenios/InserirDocumentoPrestacaoContasConvenioComArquivo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((response) => {
                    return response.data
                }).catch((error) => {
                    return errorHandler(error)
                })
        }
    },

    AlterarDocumentoPrestacaoContasConvenio(obj) {
        return axiosJwt.post(`${api}/convenios/AlterarDocumentoPrestacaoContasConvenio`, obj)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ListarDocumentoPrestacaoContas() {
        return axiosJwt
            .get(`${api}/convenios/ListarDocumentoPrestacaoContas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirAcaoPlanoTrabalho(acao) {
        return axiosJwt.post(`${api}/convenios/inseriracaoplanotrabalho`, acao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    cancelarAcaoPlanoTrabalho(id) {
        return axiosJwt
            .get(`${api}/convenios/cancelaracaoplanotrabalho/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    alterarAcaoPlanoTrabalho(acao) {
        return axiosJwt.post(`${api}/convenios/alteraracaoplanotrabalho`, acao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterEventosPorAcao(idAcaoPlanoTrabalho) {
        return axiosJwt
            .get(`${api}/convenios/acaoplanotrabalho/${idAcaoPlanoTrabalho}/eventos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterConsultoriasPorAcao(idAcaoPlanoTrabalho) {
        return axiosJwt
            .get(`${api}/convenios/acaoplanotrabalho/${idAcaoPlanoTrabalho}/consultorias`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    
    

    inserirAporteParceiro(aporte) {
        return axiosJwt.post(`${api}/convenios/outrasparcerias/inserir`, aporte)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirPendenciaDocumento(pendenciaDocumento) {
        return axiosJwt.post(`${api}/convenios/inserirpendencia`, pendenciaDocumento)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    alterarAporteParceiro(aporte) {
        return axiosJwt.post(`${api}/convenios/outrasparcerias/atualizar`, aporte)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirAporteParceiro(id) {
        return axiosJwt.patch(`${api}/convenios/outrasparcerias/excluir/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    inserirLicitacao(licitacao) {
        return axiosJwt.post(`${api}/convenios/licitacoes/inserir`, licitacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    alterarLicitacao(licitacao) {
        return axiosJwt.post(`${api}/convenios/licitacoes/atualizar`, licitacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    alterarLicitacao(licitacao) {
        return axiosJwt.post(`${api}/convenios/licitacoes/atualizar`, licitacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirLicitacao(id) {
        return axiosJwt.patch(`${api}/convenios/licitacoes/excluir/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterDocumentosLicitacao(idLicitacao) {
        return axiosJwt.get(`${api}/convenios/licitacoes/obterdocumentoslicitacao/${idLicitacao}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirDocumentoLicitacao(documento) {
        const formData = new FormData()
        formData.append('idLicitacao', documento.idLicitacao)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)
        formData.append('descricaoArquivo', documento.descricaoArquivo)

        return axiosJwt.post(`${api}/convenios/licitacoes/inserirdocumentolicitacao`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }})
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirDocumentoLicitacao(idDocumentoLicitacao) {
        return axiosJwt
            .get(`${api}/convenios/licitacoes/excluirdocumentolicitacao/${idDocumentoLicitacao}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    excluirEmpresaLicitacao(idEmpresaLicitacao) {
        return axiosJwt
            .get(`${api}/convenios/licitacoes/excluirempresalicitacao/${idEmpresaLicitacao}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    downloadDocumentoLicitacao(idLicitacao, idDocumento) {
        return axiosJwt
            .get(`${api}/convenios/licitacoes/downloaddocumentolicitacao/${idLicitacao}/${idDocumento}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    resetarPendenciaDocumento(id) {
        return axiosJwt
            .get(`${api}/convenios/resetarpendencia/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
